import { File } from './../../models/files/files.model';

export class HomeTile {
    id?: string;
    [title: string]: any;
    page_id?: string;
    icon?: string;
    file?: File;

    constructor(options: any) {
        this.id = options.id;
        // this.title = options.title;
        this.page_id = options.page_id;
        this.icon = options.icon;
        this.file = options.file;
    }
}
